<template>
  <div id="main-user">
    <el-row>
      <el-button @click="showAddUserDialog(user)">添加用户</el-button>
    </el-row>
    <el-row>
      <el-table
        :data="users"
        style="width: 90%">
        <el-table-column
          prop="id"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="showAddUserDialog(scope.row)">修改</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="loadUserRoles(scope.row.id)">角色</el-button>
              </el-col>
              <el-col :span="6">
                <el-popconfirm
                  @onConfirm="deletUser(scope.row.id)"
                  title="确定删除当前用户吗?">
                  <el-button type="danger" size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog
      :title="currentUser.title"
      :visible.sync="addUserDialog"
      width="30%">
      
      <el-row type="flex" justify="center">
        <el-col :span="21">
            <el-input v-model="currentUser.userName" :clearable="true" placeholder="用户名"></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
          <el-col :span="21">
              <el-input v-model="currentUser.phone" :clearable="true" placeholder="手机号码"></el-input>
          </el-col>
      </el-row>
      <el-row type="flex" justify="center">
          <el-col :span="21">
              <el-input v-model="currentUser.email" :clearable="true" placeholder="邮箱"></el-input>
          </el-col>
      </el-row>
      <el-row type="flex" justify="center">
          <el-col :span="21">
              <el-input v-model="currentUser.scope" :clearable="true" placeholder="可用资源"></el-input>
          </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveNewUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="用户角色"
      :visible.sync="userRoleDialog"
      width="30%">
      <el-tree
          :data="userRoleData.roles"
          show-checkbox
          node-key="roleId"
          :props= "userRoleData.permissionTreeProps"
            @check-change="handleCheckChange"
          :default-checked-keys="userRoleData.userRoleIds">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userRoleDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeUserRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { queryUsers,addUser,updateUser,removeUser,updateUserRole } from "@/api/user.js"
import { getUserRoles } from "@/api/role.js"

export default {
  name: 'User',
  data() {
    return {
      users: [],
      currentUser: {userId: null, roleIds: ""},
      addUserDialog: false,
      userRoleDialog: false,
      userRoleData: {
        roles: [],
        userRoleIds: [],
        userRoleIdSet: null,
        permissionTreeProps: {label: 'roleChName'}
      }
    }
  },
  watch: {
    
  },
  created() {
  },
  mounted() {
    this.$showLoading = true
    queryUsers().then(data=>{
      this.users = data.data.records
    })
  },
  destroyed() {
    
  },
  methods: {
    showAddUserDialog(user){
      this.currentUser = this.$options.data().currentUser
      if(user){
        this.currentUser = user
        this.currentUser.title = "修改用户信息"
      }else{
        this.currentUser.title = "新增用户"
      }
      this.addUserDialog = true
    },
    queryUser(){
      queryUsers().then(data=>{
          this.users = data.data.records
        })
    },
    saveNewUser(){
        updateUser(this.currentUser).then(()=>{
            this.addUserDialog = false
            Object.assign(this.$data.newUser , this.$options.data().newUser );
            this.queryUser()
        })
    },
    deletUser(userId){
      removeUser({"userId": userId}).then(()=>{
        this.queryUser()
      })
    },
    loadUserRoles(userId){
      this.currentUser.userId = userId;
      this.userRoleDialog = true;
      getUserRoles(userId).then(data=>{
        this.userRoleData.userRoleIdSet = new Set()
        this.userRoleData.roles = data.data
        this.userRoleData.roles.forEach(rp=>{
            if(userId!=rp.userId){
                return
            }
            this.userRoleData.userRoleIdSet.add(rp.roleId)
        })
        this.userRoleData.userRoleIds = [...this.userRoleData.userRoleIdSet]
      })
    },
    handleCheckChange(data, checked) {
        if(checked){
            this.userRoleData.userRoleIdSet.add(data.roleId)
        }else{
            this.userRoleData.userRoleIdSet.delete(data.roleId)
        }
    },
    changeUserRole(){
      this.currentUser.userId;
      let roleIds = [...this.userRoleData.userRoleIdSet]
      let data = {userId: this.currentUser.userId, roleIds: roleIds.join(",")}
      updateUserRole(data).then(()=>{
        this.userRoleDialog = false
      })
    },
  }
}
</script>

<style lang="scss">
  #main-user{
    .el-dialog .el-row{
      margin-bottom: 15px;
    }
  }
</style>
